import DomManipulate from "./DomManipulate";
require('select2');

export default class ProductGuides {

  constructor(formSelector){
    this.object = null;
    this.productid = null;
    this.make = null;
    this.year = null;
    this.model = null;
    this.trim = null;
    this.skipNextYear = false;
    this.cached = false;
  }

  init() {
    $().ready(() => {
      let productid = $('.product-guides-container').attr('data-product-id')

      if(productid === undefined || productid === null){
        console.error('Missing data-product-id in product-guides-container div');
      }else{
        this.productid = productid;
      }

      setTimeout(() =>{
        this.onChangeEvents();
      }, 250);

      //this.queryDocs();
    });
  }


  /****************************************************
   * EVENT LISTENERS
   /***************************************************/

  onChangeEvents(){

    var that = this;

    $('#js-product-guides-number').on('keyup', () => {
      that.queryDocs($("#js-product-guides-number").val());
    });

    //MAKES
    $("#js-product-guides-make").on('change', () => {

      if($("#js-product-guides-make").find(":selected").val().length !== 0) {
        this.make = $("#js-product-guides-make").find(":selected").val();
      }

      this.getGlobal($("#js-product-guides-make").find(":selected").val());
      this.queryDocs();
    });

    //YEAR
    $("#js-product-guides-year").on('change', () => {

      if($("#js-product-guides-year").find(":selected").val().length !== 0) {
        this.year = $("#js-product-guides-year").find(":selected").val();
      }

      this.buildModels();
      this.queryDocs();
    });

    //MODEL
    $("#js-product-guides-model").on('change', () => {
      if($("#js-product-guides-model").find(":selected").val().length !== 0) {
        this.model = $("#js-product-guides-model").find(":selected").val();
      }

      this.buildTrims();
      this.queryDocs();
    });

    //TRIM
    $("#js-product-guides-trim").on('change', () => {
      if($("#js-product-guides-trim").find(":selected").val().length !== 0) {
        this.trim = $("#js-product-guides-trim").find(":selected").val();
      }

      this.queryDocs();
    });


    $("#js-product-guides-connection").on('change', () => {
      this.queryDocs();
    });
    $("#js-product-guides-install").on('change', () => {
      this.queryDocs();
    });
    $("#js-product-guides-device").on('change', () => {
      this.queryDocs();
    });
  }


  /****************************************************
   * QUERIES
   /***************************************************/

  //Regular user flow starts here
  getGlobal(makeid, updateOnly = false){

    this.resetSelect("#js-product-guides-year");
    this.disableSelect("#js-product-guides-year");

    this.resetSelect("#js-product-guides-model");
    this.disableSelect("#js-product-guides-model");

    this.resetSelect("#js-product-guides-trim");
    this.disableSelect("#js-product-guides-trim");

    $("#js-product-guides-year" + " option").not(':first').remove();
    $("#js-product-guides-model" + " option").not(':first').remove();
    $("#js-product-guides-trim" + " option").not(':first').remove();

    var that = this;

    $.ajax({
      url: '/ajax/get_vehicles.php',
      method: "GET",
      data: {
        makeid: makeid
      },
    }).done(function(res){
      that.object = res;
      that.buildYears();
    }).fail(function (xhr, textStatus, errorThrown) {
      console.log(this.object);
      console.log(textStatus, errorThrown)
    });

  }

  queryDocs(guide = null){

    let data = {
      guideid: guide,
      productid: this.productid,
      makeid: $('#js-product-guides-make').val(),
      yearid: $('#js-product-guides-year').val(),
      modelid: $('#js-product-guides-model').val(),
      vehicleid: $('#js-product-guides-trim').val(),
      connection: $('#js-product-guides-connection').val(),
      install: $('#js-product-guides-install').val(),
      accessorytype: $('#js-product-guides-device').val()
    };

    $.ajax({
      url: '/ajax/guides.php',
      data: data,
      type: 'POST',
      success: function (response, textStatus, jqXHR) {

        $("#js-product-guides-results").empty();

        if(response[0] != undefined && response[0].length == 0){ //Fix bug BE
          $("#js-product-guide-noresults").removeClass('d-none');
          $("#js-product-guides-results").addClass('d-none');

        }else{

          if(response.length > 0){

            $("#js-product-guides-results").removeClass('d-none');
            $("#js-product-guide-noresults").addClass('d-none');

            var fortinUrl = "https://cdn02.fortin.ca/download/";

            for(var i = 0; i < response.length; i++){

              if($('html').attr('lang') === "en"){
                var title = response[i].description_en;
                var text = response[i].formatted_title_en;
                var groupsText = " groups supported";
              }else{
                var title = response[i].description_fr;
                var text = response[i].formatted_title_fr;
                var groupsText = " groupes pris en charge";
              }

              if (response[i].vehiclegroups !== undefined && (response[i].vehiclegroups).length > 0){
                var groups = "";

                if ((response[i].vehiclegroups).length <= 1){
                  groups += response[i].vehiclegroups[0].name;
                }else{
                  groups += (response[i].vehiclegroups).length + groupsText;
                }
              }

              var versions = "";
              const firmwares = response[i].firmwares_bypass;


              if (firmwares !== undefined && firmwares.length >= 1) {
                console.log(firmwares);

                let version1 = -1;
                if(firmwares[1] !== undefined){
                  version1 = firmwares[1].version;
                }

                let version0 = -1;
                if(firmwares[0] !== undefined){
                  version0 = firmwares[0].version;
                }

                if (version1 !== -1 && version0 === -1) {
                  versions = "Version <br/>" + response[i].firmwares_bypass[1].version.slice(-5);
                } else if (version1 === -1 && version0 !== -1) {
                  versions = "Version <br/>" + response[i].firmwares_bypass[0].version.slice(-5);
                } else if (version1 !== -1 && version0 !== -1) {
                  // Both versions (0 and 1) are defined
                  if (version0 === version1) {
                    versions = "Version <br/>"+response[i].firmwares_bypass[0].version.slice(-5);
                  } else {
                    versions = "Versions <br/>"+response[i].firmwares_bypass[0].version.slice(-5) +" - "+ response[i].firmwares_bypass[1].version.slice(-5);
                  }
                }
              }


              var anim = (i + 1) * 100;

              if(anim > 1500){
                anim = 1500;
              }

              // $("#js-product-guides-results").append(`<div class="item-content" data-aos="fade-right" data-aos-once="true" data-aos-duration="${anim}">
              //                             <div class="left">
              //                               <i class="fas fa-file-pdf fa-3x"></i>
              //                               <p>#${response[i].guideid}</p>
              //                             </div>
              //                             <div class="center">
              //                                 <a href="${fortinUrl}${response[i].guideid}/${response[i].filename}" target="_blank"><h2>${title}</h2></a>
              //                                 <p>${text}</p>
              //                             </div>
              //                             <div class="right">
              //                               <p>#${response[i].guideid}</p>
              //                              </div>
              //                         </div>`);


              $("#js-product-guides-results").append(`<div class="item-content">
                        <div class="left">
                            <i class="fas fa-file-pdf fa-3x"></i>
                            <p>#${response[i].guideid}</p>
                        </div>
                        <div class="center">
                            <a href="${fortinUrl}${response[i].guideid}/${response[i].filename}" target="_blank"><h2>${title}</h2></a>
                            <p>${text}</p>
                            <p style="margin-top: 15px;">${groups}</p>
                        </div>
                        <div class="right">
                            <p>${versions}</p>
                        </div>
                    </div>`);
            }

          }else{
            $("#js-product-guide-noresults").removeClass('d-none');
            $("#js-product-guides-results").addClass('d-none');
          }
        }
      }
    });
  }

  /****************************************************
   * PROCESSING
   /***************************************************/

  buildYears(){

    //SET YEARS
    var current
    if(this.object.make && this.object.make.years) {
      current = this.object.make.years;
    } else {
      return;
    }

    for (let i = 0; i < current.length; i++) {
      $("#js-product-guides-year").append('<option value="' + current[i].value + '">' + current[i].value + '</option>');
    }

    $("#js-product-guides-year").attr('disabled', false);
  }

  buildModels(){
    if(this.object === null || this.object === undefined ){
      return;
    }

    var yearIndex = $("#js-product-guides-year").prop('selectedIndex') - 1;
    var current  = this.object.make.years[yearIndex].models;

    this.resetSelect("#js-product-guides-model");
    this.disableSelect("#js-product-guides-model");
    $("#js-product-guides-model" + " option").not(':first').remove();

    this.resetSelect("#js-product-guides-trim");
    this.disableSelect("#js-product-guides-trim");


    for (let i = 0; i < current.length; i++) {
      $("#js-product-guides-model").append('<option value="' + current[i].modelid + '">' + current[i].name + '</option>');
    }

    $("#js-product-guides-model").attr('disabled', false);
  }

  buildTrims(){

    if(this.object === null || this.object === undefined){
      return;
    }

    this.resetSelect("#js-product-guides-trim");
    this.disableSelect("#js-product-guides-trim");
    $("#js-product-guides-trim" + " option").not(':first').remove();


    var yearIndex = $("#js-product-guides-year").prop('selectedIndex') - 1;
    var modelIndex = $("#js-product-guides-model").prop('selectedIndex') - 1;

    var current  = this.object.make.years[yearIndex].models[modelIndex].trims;

    for (let i = 0; i < current.length; i++) {
      $("#js-product-guides-trim").append('<option value="' + current[i].url + '">' + current[i].name + '</option>');
    }

    $("#js-product-guides-trim").attr('disabled', false);
  }


  /****************************************************
   * HTML CHANGES
   /***************************************************/

  resetSelect(selector) {
    $(selector + " option").removeAttr('selected');
    $(selector).val('').trigger('change.select2');
  }

  disableSelect(selector) {
    $(selector).attr("disabled", true);
  }
};


